var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgBarsOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.49 2.75498C16.49 1.23345 17.7235 0 19.245 0C20.7666 0 22 1.23345 22 2.75498V19.245C22 20.7666 20.7666 22 19.245 22C17.7235 22 16.49 20.7666 16.49 19.245V2.75498ZM19.245 1.53488C18.5712 1.53488 18.0249 2.08114 18.0249 2.75498V19.245C18.0249 19.9189 18.5712 20.4651 19.245 20.4651C19.9189 20.4651 20.4651 19.9189 20.4651 19.245V2.75498C20.4651 2.08114 19.9189 1.53488 19.245 1.53488ZM8.26377 6.94186C8.26377 5.4256 9.49715 4.19866 11.0134 4.20659C12.5299 4.21453 13.7555 5.44518 13.7573 6.96167L13.7716 19.244C13.7734 20.7656 12.5404 22 11.0188 22C9.49725 22 8.26377 20.7665 8.26377 19.2449V6.94186ZM11.0054 5.74145C10.3399 5.73797 9.79866 6.27643 9.79866 6.94186V19.2449C9.79866 19.9188 10.3449 20.4651 11.0188 20.4651C11.692 20.4651 12.2375 19.919 12.2367 19.2458L12.2224 6.96345C12.2216 6.29082 11.678 5.74497 11.0054 5.74145ZM1.846 14.4666C1.68378 14.6302 1.54445 14.9191 1.54124 15.4174C1.5376 15.9825 1.53488 16.6378 1.53488 17.3421V19.245C1.53488 19.9189 2.08114 20.4651 2.75498 20.4651C3.42882 20.4651 3.97507 19.9189 3.97507 19.245V15.3608C3.97507 14.7008 3.44001 14.1657 2.77999 14.1657C2.28801 14.1657 2.00648 14.3046 1.846 14.4666ZM0.755873 13.3861C1.27705 12.8602 1.99449 12.6308 2.77999 12.6308C4.28771 12.6308 5.50995 13.8531 5.50995 15.3608V19.245C5.50995 20.7666 4.27651 22 2.75498 22C1.23345 22 0 20.7666 0 19.245V17.3421C0 16.6339 0.00273202 15.9753 0.00639147 15.4075C0.0114132 14.6283 0.236438 13.9101 0.755873 13.3861Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsOutlined);
export default __webpack_public_path__ + "static/media/barsOutlined.36658e54ef33ed9c1e58a545f901f1ee.svg";
export { ForwardRef as ReactComponent };